module.exports = __webpack_public_path__ + "img/store_no_data.bda31be0.svg";